/* ============================================================
   Constantes partilhadas do catálogo de vinhos — Douro Nostrum
   ============================================================
   O catálogo em si vem da API (ver src/context/WinesContext.js).
   Este ficheiro guarda só a lista fixa dos tipos, que corresponde
   ao enum WineType do backend.
   ============================================================ */

export const WINE_TYPES = ['Tinto Colheita', 'Branco Colheita', 'Tinto Reserva', 'Branco Reserva'];
